import { CommitableDataSlidePanel } from "@/components/slide-panel";
import Dropdown from "@/components/dropdown";
import { notEmpty } from '@/lib/helpers';
import User from '@/lib/models/user';
import { Component, Mixins } from "vue-property-decorator";
import Icon from '@/components/icon';
import { Getter } from 'vuex-class';
import ComDept from '@/lib/models/com-dept';

@Component
export default class PanelUser extends Mixins<CommitableDataSlidePanel<User>>(CommitableDataSlidePanel) {

  @Getter getLexique;

  get depts() {
    return this.getLexique("ComDept");
  }

  get userDeptListOrdered(): string[] {
    if (this.data.depts?.length) {
      if (this.data.depts === "ALL") {
        return this.depts.map(d => d.numDept);
      } else {
        return this.data.depts.split(",").map(s => s.trim());
      }
    }
    return [];
  }

  async created() {
    this.create && (this.data = new User());
    this.validators = [
      {fn: d => notEmpty(d.depts), message: "Au moins un départemnet est requis"},
    ];
  }

  isDeptSelected(d: ComDept): boolean {
    return this.data.depts === "ALL" || this.userDeptListOrdered.some(v => v === d.numDept);
  }

  toggleDept(d: ComDept) {
    const selection = [...this.userDeptListOrdered];
    const idx = selection.findIndex(v => v === d.numDept);
    if (~idx) { //remove
      selection.splice(idx, 1);
    } else {
      selection.push(d.numDept);
    }
    this.data.depts = selection.join(",");
  }

  toggleAllDepts() {
    if (this.data.depts === "ALL") {
      this.data.depts = "";
    } else {
      this.data.depts = "ALL";
    }
  }

  mounted() {}

  renderHead() {
    return <span>Utilisateur</span>
  }

  renderBody() {
    if (!this.data) return null;
    return (
      <div class="basic">

        <div class="field">
          <label class="label is-small">Départements (*)</label>
          <p class="control">
          <Dropdown class="list-dropdown" closeOnClickLayer={false}
              scopedSlots={{
                trigger: () => (
                  <a class="action">
                    <span class="trigger-label">Sélectionner</span>
                    <Icon icon="caret-down" class="icon caret-icon grey"/>
                  </a>
                ),
                layer: () => (
                  <div class="list-dropdown__layer">
                    <ul>
                      <li class={`dd-option`}>
                        <div class="is-flex is-airy" onClick={() => this.toggleAllDepts()}>
                        Tout {this.data.depts === "ALL" ? 'dé':''}sélectionner
                        </div>
                      </li>
                      {this.depts?.map(v => (
                        <li class={`dd-option`}>
                          <div class="is-flex is-airy" onClick={() => this.toggleDept(v)}>
                            <input type="checkbox"
                              checked={this.isDeptSelected(v)}/>
                            <span>({v.numDept}) {v.nom}</span>
                          </div>
                        </li>
                      ))}
                    </ul>
                  </div>
                )
              }}
            />
          </p>
        </div>

      </div>
    );
  }

}

// VUE JSX HOT LOADER //
if (module.hot) require("/Users/home/j2ee/projects/cavites/src/main/client/node_modules/vue-jsx-hot-loader/src/api.js")({ Vue: require('vue'), ctx: eval('this'), module: module, hotId: "_vue_jsx_hot-2bd83550/panel-user.tsx" });